/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureApimDetails {
    getFixupPrototypeFunction() { return AzureApimDetails.fixupPrototype; }

    static newInstance(model: Partial<AzureApimDetails>): AzureApimDetails {
        let obj = Object.assign(new AzureApimDetails(), model);
        AzureApimDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureApimDetails>): AzureApimDetails {
        if (!model) return null;
        return AzureApimDetails.newInstance(<AzureApimDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureApimDetails) {
        if (!obj) return;

        models.AzureApimDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureApimDetails): boolean {
        Object.setPrototypeOf(obj, AzureApimDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Full ARM id of the API Management service fronting the AI accounts
     */
    apim_resource_id: string;

    /**
     * API Management service name, for display
     */
    apim_name: string;

}
